import type { Quote } from '@/lib/market/types'

export const buyInitiatedShare = (quote: Quote, sigma: number, noise: number): number => {
    const move = quote.prevClose > 0 ? (quote.last - quote.prevClose) / quote.prevClose : 0
    const scaled = sigma > 0 ? move / sigma : 0
    const soft = scaled / (1 + Math.abs(scaled))

    return Math.min(0.95, Math.max(0.05, 0.5 + 0.3 * soft + 0.16 * noise))
}

export const orderFlowSplit = (quote: Quote, sigma: number, noise: number): { buy: number, sell: number, share: number, imbalance: number } => {
    const share = buyInitiatedShare(quote, sigma, noise)
    const buy = Math.round(quote.volume * share)
    const sell = quote.volume - buy

    return { buy, sell, share, imbalance: quote.volume > 0 ? (buy - sell) / quote.volume : 0 }
}
